export { default as useNeighbouringTabs } from "./useNeighbouringTabs";
